import { useEffect } from "react";
import LandingNav from "../components/landing/LandingNav";
import Hero from "../components/landing/Hero";
import Problem from "../components/landing/Problem";
import PassportSection from "../components/landing/PassportSection";
import QrSection from "../components/landing/QrSection";
import HowItWorks from "../components/landing/HowItWorks";
import Memory from "../components/landing/Memory";
import SearchDemo from "../components/landing/SearchDemo";
import Devices from "../components/landing/Devices";
import Differentiation from "../components/landing/Differentiation";
import SecuritySummary from "../components/landing/SecuritySummary";
import DemoSection from "../components/landing/DemoSection";
import Principles from "../components/landing/Principles";
import Why from "../components/landing/Why";
import FinalCta from "../components/landing/FinalCta";
import Footer from "../components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 150);
    }
  }, []);

  return (
    <div className="min-h-screen bg-zinc-50" data-testid="landing-page">
      <LandingNav />
      <main>
        <Hero />
        <Problem />
        <PassportSection />
        <QrSection />
        <DemoSection />
        <HowItWorks />
        <Memory />
        <SearchDemo />
        <Devices />
        <Differentiation />
        <SecuritySummary />
        <Principles />
        <Why />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
